import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import SnackbarContent from '@mui/material/SnackbarContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const StyledMain = styled('main')(({ theme }) => ({
    width: 'auto',
    marginLeft: typeof theme?.spacing === 'function' ? theme.spacing(3) : '24px',
    marginRight: typeof theme?.spacing === 'function' ? theme.spacing(3) : '24px',
    [theme?.breakpoints?.up ? theme.breakpoints.up(400 + parseInt(typeof theme?.spacing === 'function' ? theme.spacing(6) : '48px', 10)) : '@media (min-width: 448px)']: {
        width: 400,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    marginTop: typeof theme?.spacing === 'function' ? theme.spacing(8) : '64px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: typeof theme?.spacing === 'function' ? theme.spacing(2, 3, 3) : '16px 24px 24px',
    position: 'relative',
}));

const StyledForm = styled('form')(({ theme }) => ({
    marginTop: typeof theme?.spacing === 'function' ? theme.spacing(1) : '8px',
}));

const StyledButton = styled(Button)(({ theme }) => ({
    marginTop: typeof theme?.spacing === 'function' ? theme.spacing(3) : '24px',
}));

const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => ({
    backgroundColor: theme?.palette?.error?.dark || '#c62828',
}));

const LoginForm = ({ values, error, loading, onSubmit, onFieldChange }) => (
    <>
        <CssBaseline />
        <StyledMain>
            <StyledPaper>
                <Typography component="h1" variant="h5">Sign in</Typography>
                {error ? <StyledSnackbarContent message={error} /> : null}
                <StyledForm onSubmit={onSubmit}>
                    <FormControl required fullWidth margin="normal" >
                        <InputLabel htmlFor="login">Login</InputLabel>
                        <Input
                            autoFocus
                            id="login"
                            name="login"
                            value={values.login}
                            onChange={onFieldChange}
                        />
                    </FormControl>
                    <FormControl required fullWidth margin="normal">
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input
                            name="password"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={values.password}
                            onChange={onFieldChange}
                        />
                    </FormControl>
                    <StyledButton
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                    >
                        Sign in
                    </StyledButton>
                </StyledForm>
            </StyledPaper>
        </StyledMain>
    </>
);

LoginForm.propTypes = {
    values: PropTypes.shape({
        login: PropTypes.string,
        password: PropTypes.string,
    }).isRequired,
    error: PropTypes.string,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
};

export default LoginForm;
